import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const Content = styled.div`
  width: 70%;
  margin: 0px auto;
  padding-left: 100px;
`;
export const TemplateNameBlock = styled.div`
  width: 55%;
  margin-left: 20px;
  margin-right: 15px;
  display: flex;
  flex-direction: column;
`;
export const UploadedVideo = styled.p`
  color: gray;
`;

export const Warning = styled.h1`
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
  color: red;
`;
export const ComplexityBlock = styled.div`
  margin: 0px 10px 0px 20px;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  width: 100%;
  font-size: 24px;
  cursor: pointer;
  margin: 5px;
`;
export const LabelLength = styled.div`
  // margin-top:10px;
  margin-bottom:25px;
  // margin: 10px;
  width: 100%;
  font-size: 24px;
  cursor: pointer;
`;
export const FooterBlock = styled.div`
  height: 50px;
`;
export const TypeBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
export const MainTitle = styled.h1`
  font-size: 20px;
  text-align: center;
  padding-top: 25px;
`;
export const Message = styled.span`
  display: inline-block;
  color: #ea1b00;
  margin: 0 3px;
`;
export const Item = styled.div`
  width: 100%;
  margin: 15px auto;
  display: flex;
  justify-content: flex-start;
`;
export const CheckboxWrapper = styled.div`
  width: 60%;
  padding: 2px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 auto;

  @media (max-width: 580px) {
    width: 100%;
    padding-left: 20%;
  }
`;

export const InputBlock = styled.div`
  display: flex;
  width: 260px;

`;

export const TimeContentBlock = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  // margin-bottom: 5px;
  margin-left: 15px;

`;

export const AddButtonBlock = styled.div`
  width: 100%;
  margin: 0px auto;
  margin-left: -20px;
`;
const activeClassName = 'active';

export const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})`
  display: block;
  height: 100%;
  padding: 0 10px;
  color: #ffffff;
  line-height: 50px;
  text-decoration: none;
  transition: all 0.3s;
  background: #17ade3;
  &:hover {
    background: #157aac;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
  &.${activeClassName} {
    background: #157aac;
  }
`;
export const LinkBlock = styled.div`
  background: #17ade3;
  display: flex;
  justify-content: center;
  margin-top: -50px;
`;
export const ImageVideoBlock = styled.div`
  display: flex;
  flex-direction: column;
  // margin-top: 15px;
  margin: 10px 5px 10px 20px;
`;
export const FlexBlock = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex-basis: 50%;
  justify-content: flex-start;
  align-items: center;
`;
export const ToggleBlock = styled.div`
  dispay: flex;
  flex-direction: row;
`;
export const FirstBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ButtonBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: center;
  margin: 20px auto 0;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateTraining/CreateTrainingStyles.js